/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monsterbtnlabel2Inputs */



/**
* | output |
* | --- |
* | "MONSTER" |
*
* @param {Monsterbtnlabel2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const monsterbtnlabel2 = /** @type {((inputs?: Monsterbtnlabel2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monsterbtnlabel2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("MONSTER")
	if (locale === "es") return /** @type {LocalizedString} */ ("MONSTER")
	return /** @type {LocalizedString} */ ("МОНСТР")
});
export { monsterbtnlabel2 as "monsterBtnLabel" }